import { render, staticRenderFns } from "./BDXStatusModalFilters.vue?vue&type=template&id=2903b060&scoped=true"
import script from "./BDXStatusModalFilters.vue?vue&type=script&lang=js"
export * from "./BDXStatusModalFilters.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusModalFilters.vue?vue&type=style&index=0&id=2903b060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2903b060",
  null
  
)

export default component.exports